import React from "react"
import Layout from "../components/layout"
import Home from "../components/home"
import Subscribe from "../components/subscribe"

function IndexPage() {
  return(
    <Layout>
        <Home />
        <div style={{ marginTop: '5rem' }} />
        <Subscribe />
    </Layout>
  )
}

export default IndexPage
